import React from 'react'
import Loading from '../../components/Loading/Loading'
import styles from './LoadingPage.module.css'

const LoadingPage = () => {
  return (
  <div className={styles.loadingPage}>
    <Loading />
  </div>
  );
};

export default LoadingPage;
